module.exports = "/work-site/img/word.40c3a21c.jpg";